import { PLANT_COLORS } from "@/lib/container/layout";

/**
 * Planting-diagram key numbers for the OUTDOOR result.
 *
 * The outdoor diagram (api/services/diagram_renderer.py) numbers its plants
 * 1..N in name order after dropping plants the counter reported at 0
 * (`order_plants_for_key` + `drop_zero_count_plants` in ai_service.py). The
 * shopping list applies the same rule here so the badge on the plan and the
 * badge on the row always agree. Colors are the container palette, which the
 * renderer copies, so both result pages read as one family.
 */
export interface PlantKeyEntry {
  number: number;
  color: string;
}

const sortKey = (name: string | undefined) => (name ?? "").trim().toLowerCase();

export function plantKeyNumbers(
  plants: { id: string; commonName?: string }[],
  quantities: Record<string, number>
): Record<string, PlantKeyEntry> {
  const used = plants.filter((p) => quantities[p.id] !== 0);
  // Python's sorted() on str.lower(): plain code-point comparison, stable on ties.
  const ordered = used
    .map((p, i) => ({ p, i, k: sortKey(p.commonName) }))
    .sort((a, b) => (a.k < b.k ? -1 : a.k > b.k ? 1 : a.i - b.i));
  const out: Record<string, PlantKeyEntry> = {};
  ordered.forEach(({ p }, idx) => {
    out[p.id] = {
      number: idx + 1,
      color: PLANT_COLORS[idx % PLANT_COLORS.length],
    };
  });
  return out;
}
